import { forwardRef } from 'react';
import Tooltip from '../../Tooltip';
import { StyledNavLink, StyledNavLinkButton } from './styled';

const NavLink = forwardRef((props, ref) => {
  const { as, to, tooltip, tooltipPlacement = 'right', ...rest } = props;

  if (as === 'button') {
    if (tooltip) {
      return (
        <Tooltip text={tooltip} placement={tooltipPlacement}>
          <StyledNavLinkButton ref={ref} {...rest} />
        </Tooltip>
      );
    } else {
      return <StyledNavLinkButton ref={ref} {...rest} />;
    }
  } else {
    if (tooltip) {
      return (
        <Tooltip text={tooltip} placement={tooltipPlacement}>
          <StyledNavLink ref={ref} to={to} {...rest} />
        </Tooltip>
      );
    } else {
      return <StyledNavLink ref={ref} to={to} {...rest} />;
    }
  }
});

export default NavLink;
